import { render, staticRenderFns } from "./ConsumerHoverComponent.vue?vue&type=template&id=2ca65a39"
import script from "./ConsumerHoverComponent.vue?vue&type=script&lang=js"
export * from "./ConsumerHoverComponent.vue?vue&type=script&lang=js"
import style0 from "./ConsumerHoverComponent.vue?vue&type=style&index=0&id=2ca65a39&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports